module.exports = __webpack_public_path__ + "media/images/gallagher_lifetime_logo-9ac76385b0034a88ff62c4662bcc4a84.png";